import { axiosWithRetryInstance } from "@/api/base";

export const getPdfContent = async (fseId: string) =>
  axiosWithRetryInstance.get<Blob>("/pf-document/document", {
    responseType: "blob",
    params: { fse_id: fseId },
  });
